import { HttpBackend } from '@angular/common/http';
import { Directive, effect, inject, input } from '@angular/core';
import {
  provideTranslateService,
  TranslateLoader,
  TranslateService,
} from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { environment } from '../../../../environments/environment';
import { type SupportedLanguage } from '../../../app.i18n';

function i18nHttpLoaderFactory(http: HttpBackend) {
  return new MultiTranslateHttpLoader(http, [
    {
      prefix: './assets/i18n/',
      suffix: `.json?v=${environment.buildNumber}`,
    },
  ]);
}

/**
 * Directive that provides a TranslateService scoped to a given language.
 * Place it on a container; descendants will resolve translations using that
 * language (e.g. SUPPORTED_LANGUAGES), not the platform language.
 *
 * Usage:
 *   <div squadboxTranslationLanguageContext [squadboxTranslationLanguageContext]="selectedLanguage()">
 *     <!-- content with | translate will use selectedLanguage -->
 *   </div>
 */
@Directive({
  selector: '[squadboxTranslationLanguageContext]',
  standalone: true,
  providers: [
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: i18nHttpLoaderFactory,
        deps: [HttpBackend],
      },
    }),
  ],
})
export class TranslationLanguageContextDirective {
  private readonly translateService = inject(TranslateService);

  /** Language for this context (e.g. SUPPORTED_LANGUAGES: 'en' | 'fr'). */
  squadboxTranslationLanguageContext = input.required<SupportedLanguage>();

  constructor() {
    effect(() => {
      this.translateService.use(this.squadboxTranslationLanguageContext());
    });
  }
}
